import React from 'react';
import JobFitModal from './JobFitModal';
import JobFitTeaserCard from './JobFitTeaserCard';
import { useJobFitFlow } from './useJobFitFlow';
import './job-fit-card.css';

type JobFitCardProps = {
  jobId: string;
  jobTitle: string;
  company?: string;
  featured: boolean;
  onEasyApply?: () => void;
};

const JobFitCard: React.FC<JobFitCardProps> = ({
  jobId,
  jobTitle,
  company,
  featured,
  onEasyApply,
}) => {
  const flow = useJobFitFlow(jobId);

  return (
    <>
      <JobFitTeaserCard jobTitle={jobTitle} flow={flow} />
      <JobFitModal
        jobTitle={jobTitle}
        company={company}
        featured={featured}
        flow={flow}
        onEasyApply={onEasyApply}
      />
    </>
  );
};

export default JobFitCard;
